import styled from "styled-components";

import { Container, IconButton } from "@material-ui/core";

const orange = (props) => props.theme.palette.orange;
const primary = (props) => props.theme.palette.primary;
const secondary = (props) => props.theme.palette.secondary;
const lightSubgrey = (props) => props.theme.palette.darkgrey;
const montserrat = (props) => props.theme.fonts.montserrat;
const mulish = (props) => props.theme.fonts.mulish;

export const PainelContainer = styled(Container)`
  margin-top: 15vh;
`;

export const Header = styled.div`
  width: 100%;
`;
export const Body = styled.div`
  width: 100%;
`;

export const HeaderAccordion = styled.div`
  width: 100%;

  .MuiChip-root {
    cursor: pointer;
    padding: 20px;
    width: 100%;
    margin: 0;
    span {
      font-weight: bolder;
      font-family: ${mulish};
      font-size: 1.2rem;
    }
  }
`;

export const TableContent = styled.div`
  width: 100%;
  .MuiChip-root {
    width: 100%;
    margin: 0;
    font-size: 1rem;
    font-family: ${mulish};
    font-weight: bolder;
  }
  Table {
    min-width: 0px !important;
    Thead {
      background-color: ${secondary};
      box-shadow: 3px 3px 3px ${lightSubgrey};
      tr {
        th {
          span {
            font-family: ${montserrat}, sans-serif !important;
          }
        }
      }
    }
    Tbody {
      tr {
        height: 0px !important;
      }
      td {
        font-family: ${montserrat}, sans-serif !important;
      }
    }
  }
`;

export const IconButtonStyled = styled(IconButton)`
  background-color: ${primary} !important;
  color: white !important;

  :hover {
    background-color: ${orange} !important;
  }

  img {
    width: 20px;
    margin: 3px;
  }
`;
